export default "__VITE_ASSET__DdUK38Sn__"